import React from 'react';
import { WeekChallengePlayfulCard } from './WeekChallengePlayfulCard';
import { WeekChallengePlayfulActivities } from './WeekChallengePlayfulActivities';
import { Loader } from '@/components/custom/loader';
import { EmptyState } from '@/components/custom/empty-state';
import { Page, PageContent, PageSidebar } from '@/components/custom/page';
import { CardWrapper } from '@/components/ui/card';

export function WeekChallengePlayfulChallenges({ challenges, isLoading }) {
  if (isLoading) return <Loader />;

  return (
    <Page>
      <PageContent>
        {challenges?.length > 0 ? (
          <CardWrapper>
            {challenges.map(item => (
              <WeekChallengePlayfulCard
                key={item.id}
                challenge={item}
              />
            ))}
          </CardWrapper>
        ) : (
          <EmptyState
            type="content"
            title="Nenhum desafio por aqui"
            text="Ainda não há desafios da semana disponíveis. Volte em breve!"
            variant="plain"
            className="pt-16"
          />
        )}
      </PageContent>

      <PageSidebar variant="md">
        <WeekChallengePlayfulActivities conquers={challenges?.filter(item => item.done)} />
      </PageSidebar>
    </Page>
  );
}
